// src/pages/Profile/utils/profileUtils.js

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const withBust = (url, version) => {
  if (!url) return url;

  return url.includes("?") ? `${url}&v=${version}` : `${url}?v=${version}`;
};

export const getStoredUserInfo = () => {
  try {
    const localStorageUser = localStorage.getItem("userInfo");
    return localStorageUser ? JSON.parse(localStorageUser) : null;
  } catch (error) {
    console.error("Erreur lecture userInfo localStorage:", error);
    return null;
  }
};

export const updateLocalStorageUser = (payload = {}) => {
  try {
    const currentInfo = localStorage.getItem("userInfo");
    const stored = currentInfo ? JSON.parse(currentInfo) : {};

    localStorage.setItem(
      "userInfo",
      JSON.stringify({
        ...stored,
        ...payload,
      })
    );
  } catch (error) {
    console.error("Erreur mise à jour userInfo localStorage:", error);
  }
};

export const getDisplayName = (user = {}) => {
  const fullName = `${user.prenom || ""} ${user.nom || ""}`.trim();

  return fullName || "Profil utilisateur";
};

export const normalizeUserFromApi = (previousUser = {}, userData = {}) => {
  return {
    ...previousUser,
    ...userData,
    email_notifications_enabled: !!userData.email_notifications_enabled,
    push_notifications_enabled: !!userData.push_notifications_enabled,
  };
};